import React from 'react';
import parse from "html-react-parser";
import { useState, useEffect } from 'react';
import {
    Container,
    CloseButton,
    Spinner
} from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import { getFichaUrl } from '../utils/utils';
import { getPopupFichaContent } from '../api';


export default function PopupFicha({ ficha, opcoes, menuDisabled, onChange }) {
    const [content, setContent] = useState(null)
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (ficha) {
            setLoading(true);
            getPopupFichaContent(ficha).then(({metaHTML, imgUrl}) => {
                setContent({
                    imgUrl: imgUrl,
                    metaHTML: metaHTML
                });
                setLoading(false);
            });
        }
    }, [ficha]);

    return (
        <Fade when={ficha !== null} collapse>
                <div id="popupFichaWrapper" className={menuDisabled ? '' : 'withMenu'}>
                    <Container id="popupFicha">
                        <CloseButton
                            onClick={(e) => onChange()}
                        />
                        {(loading || !ficha)
                            ? <div id="popupFichaLoading">
                                    <Spinner
                                        animation="border"
                                        role="status"
                                        variant="warning"
                                    >
                                        <span className="visually-hidden">Carregando...</span>
                                    </Spinner>
                            </div>
                            : <>
                            {(content.imgUrl) &&
                                <img
                                    id="popupFichaImg"
                                    alt={ficha.post_title}
                                    src={content.imgUrl}
                                />
                            }
                            <h1>{ficha.post_title}</h1>
                            <div>
                                <a href={getFichaUrl(ficha.post_name)}>
                                    Abrir cadastro completo
                                </a>
                            </div>
                            <div>
                                {parse(content.metaHTML)}
                            </div>
                            <div>
                              <p>{ficha.meta.descricao}</p>
                            </div>
                            <div>
                                <a href={getFichaUrl(ficha.post_name)}>
                                    Abrir cadastro completo
                                </a>
                            </div>
                            </>
                        }
                    </Container>
                </div>
        </Fade>
    );
}
